import React from 'react';
import ConstitutionDay2024  from 'views/ConstitutionDay2024';
const ClassAssembly11CPage = () => {
    return <ConstitutionDay2024 />;
  };
  
  export default ClassAssembly11CPage;

  